/**
 * Cookie / analytics consent preference (first-party, essential).
 * Values: 'accepted' | 'rejected' | null (no choice yet).
 */

export const CONSENT_STORAGE_KEY = 'elm_cookie_consent';
export const CONSENT_VERSION_KEY = 'elm_cookie_consent_v';
export const CONSENT_VERSION = '1';
export const OPEN_COOKIE_SETTINGS_EVENT = 'elm:open-cookie-settings';

/**
 * @returns {'accepted'|'rejected'|null}
 */
export function getConsent() {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const storedVersion = window.localStorage.getItem(CONSENT_VERSION_KEY);
    if (storedVersion !== CONSENT_VERSION) {
      return null;
    }
    const value = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (value === 'accepted' || value === 'rejected') {
      return value;
    }
  } catch {
    // localStorage blocked
  }
  return null;
}

/**
 * @param {'accepted'|'rejected'} value
 */
export function setConsent(value) {
  if (typeof window === 'undefined') {
    return;
  }
  if (value !== 'accepted' && value !== 'rejected') {
    return;
  }
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, value);
    window.localStorage.setItem(CONSENT_VERSION_KEY, CONSENT_VERSION);
  } catch {
    // localStorage blocked
  }
}

export function clearConsent() {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.removeItem(CONSENT_STORAGE_KEY);
    window.localStorage.removeItem(CONSENT_VERSION_KEY);
  } catch {
    // localStorage blocked
  }
}

export function hasAnalyticsConsent() {
  return getConsent() === 'accepted';
}

/** Ask ConsentBanner to show again (after clearing or for settings reopen). */
export function openCookieSettings() {
  if (typeof window === 'undefined') {
    return;
  }
  clearConsent();
  window.dispatchEvent(new CustomEvent(OPEN_COOKIE_SETTINGS_EVENT));
}
